export const getUpSellAndCrossSellsUrl = (integrationId: number) =>
  `business/integrations/${integrationId}/item_upsells_crosssells`;

export const getUpSellAndCrossSellUrl = (integrationId: number, getUpSellAndCrossSellId: number) =>
  `business/integrations/${integrationId}/item_upsells_crosssells/${getUpSellAndCrossSellId}`;

export const getMenuOptionsUrl = (locationId: number) => `/business/locations/${locationId}/pos/menus`;

export const updateMenuUrl = (locationId: number, menuId: number) =>
  `/business/locations/${locationId}/pos/menus/${menuId}`;

export const getMenuItemsUrl = (locationId: number, menuId: number) =>
  `/business/locations/${locationId}/pos/menus/${menuId}/menu_items`;

export const getMenuItemModifiersUrl = (locationId: number, menuId: number, menuItemId: number) =>
  `/business/locations/${locationId}/pos/menus/${menuId}/menu_items/${menuItemId}/modifiers`;

export const getAllItemsUrl = (locationId: number) => `business/locations/${locationId}/pos/menu_items`;

export const getAlternativeNamesUrl = (integrationId: number) =>
  `business/integrations/${integrationId}/alternative_names`;

export const getAlternativeNameUrl = (integrationId: number, alternativeNameId: number) =>
  `business/integrations/${integrationId}/alternative_names/${alternativeNameId}`;
